import React from 'react';
import { Book, ShoppingCart, ChefHat, Calendar, Package } from 'lucide-react';
export function SolutionSection() {
  const tomos = [{
    icon: <Book className="text-gold-500" size={28} data-id="element-168" />,
    title: '📕 TOMO 1 – Sistema Freezer Inteligente',
    desc: 'Cómo dejar de improvisar y organizar tu freezer para que te resuelva de verdad.'
  }, {
    icon: <ShoppingCart className="text-gold-500" size={28} data-id="element-169" />,
    title: '📘 TOMO 2 – Compras Inteligentes y Stock de Base',
    desc: 'Cómo comprar mejor, gastar menos y tener siempre ingredientes que resuelven.'
  }, {
    icon: <ChefHat className="text-gold-500" size={28} data-id="element-170" />,
    title: '📗 TOMO 3 – Cocina Base Freezer-Friendly',
    desc: 'Cómo cocinar una vez y dejar adelantadas bases, porciones y comidas prácticas.'
  }, {
    icon: <Calendar className="text-gold-500" size={28} data-id="element-171" />,
    title: '📙 TOMO 4 – 30 Menús para 30 Días',
    desc: 'Ideas concretas para no pensar todos los días qué cocinar.'
  }, {
    icon: <Package className="text-gold-500" size={28} data-id="element-172" />,
    title: '📕 TOMO 5 – Viandas, Ahorro y Mantenimiento',
    desc: 'Cómo sostener el sistema con viandas, rotación y ahorro real.'
  }];
  return <section className="w-full bg-peach py-16 px-4 flex flex-col items-center" data-id="element-173">
      <div className="max-w-4xl w-full" data-id="element-174">
        <div className="text-center mb-12" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold text-brown-800 mb-6" data-id="element-176">
            ✅ LA SOLUCIÓN FREEZER INTELIGENTE
          </h2>
          <p className="text-lg md:text-xl text-brown-600 max-w-3xl mx-auto" data-id="element-177">
            Una colección completa en 5 TOMOS + 3 BONOS para ayudarte a cocinar
            menos veces, organizar mejor tus comidas y bajar el delivery con una
            forma simple, práctica y realista.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md mb-16 border border-gold-400/30" data-id="element-178">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center" data-id="element-179">
            <div className="flex flex-col items-center" data-id="element-180">
              <div className="text-4xl mb-3" data-id="element-181">📂</div>
              <p className="font-bold text-brown-800 text-lg" data-id="element-182">
                Accedés al contenido
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-183">
              <div className="text-4xl mb-3" data-id="element-184">👆</div>
              <p className="font-bold text-brown-800 text-lg" data-id="element-185">
                Aplicás paso a paso
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-186">
              <div className="text-4xl mb-3" data-id="element-187">🥘</div>
              <p className="font-bold text-brown-800 text-lg" data-id="element-188">
                Resolvés tus comidas con menos estrés y menos gasto
              </p>
            </div>
          </div>
        </div>

        <h3 className="text-2xl md:text-3xl font-bold text-brown-800 mb-8 text-center" data-id="element-189">
          📘 ¿QUÉ INCLUYE EXACTAMENTE FREEZER INTELIGENTE?
        </h3>

        <div className="space-y-4" data-id="element-190">
          {tomos.map((tomo, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-sm flex items-start gap-4 border border-peach hover:shadow-md transition-shadow" data-id="element-191">
              <div className="bg-peach p-3 rounded-full shrink-0" data-id="element-192">
                {tomo.icon}
              </div>
              <div data-id="element-193">
                <h4 className="text-xl font-bold text-brown-800 mb-2" data-id="element-194">
                  {tomo.title}
                </h4>
                <p className="text-brown-600" data-id="element-195">{tomo.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 flex justify-center" data-id="element-196">
          <a href="#compra" className="bg-gradient-to-r from-gold-400 to-gold-500 text-white font-bold text-lg py-4 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-full max-w-md text-center" data-id="element-197">
            👉 VER OFERTA COMPLETA
          </a>
        </div>
      </div>
    </section>;
}